import { render } from "./DesktopHeader.vue?vue&type=template&id=3ea82044&scoped=true"
import script from "./DesktopHeader.vue?vue&type=script&lang=js"
export * from "./DesktopHeader.vue?vue&type=script&lang=js"

import "./DesktopHeader.vue?vue&type=style&index=0&id=3ea82044&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ea82044"

export default script